import z6, { z } from 'zod';

// src/enums/attribute.ts
var AttributeType = /* @__PURE__ */ ((AttributeType2) => {
  AttributeType2["TEXT"] = "text";
  AttributeType2["NUMBER"] = "number";
  AttributeType2["CHECKBOX"] = "checkbox";
  AttributeType2["SELECT"] = "select";
  return AttributeType2;
})(AttributeType || {});

// src/enums/configuration.ts
var ConfigurationKey = /* @__PURE__ */ ((ConfigurationKey2) => {
  ConfigurationKey2["SERVICE_GST_RATE"] = "SERVICE_GST_RATE";
  ConfigurationKey2["TCS_RATE"] = "TCS_RATE";
  ConfigurationKey2["TDS_RATE"] = "TDS_RATE";
  return ConfigurationKey2;
})(ConfigurationKey || {});
var ConfigurationType = /* @__PURE__ */ ((ConfigurationType2) => {
  ConfigurationType2["STRING"] = "STRING";
  ConfigurationType2["STRING_ARRAY"] = "STRING_ARRAY";
  ConfigurationType2["BOOLEAN"] = "BOOLEAN";
  ConfigurationType2["BOOLEAN_ARRAY"] = "BOOLEAN_ARRAY";
  ConfigurationType2["NUMBER"] = "NUMBER";
  ConfigurationType2["NUMBER_ARRAY"] = "NUMBER_ARRAY";
  ConfigurationType2["DATE"] = "DATE";
  ConfigurationType2["DATE_ARRAY"] = "DATE_ARRAY";
  ConfigurationType2["OBJECT"] = "OBJECT";
  ConfigurationType2["OBJECT_ARRAY"] = "OBJECT_ARRAY";
  ConfigurationType2["ENUM"] = "ENUM";
  ConfigurationType2["FILE"] = "FILE";
  ConfigurationType2["FILE_ARRAY"] = "FILE_ARRAY";
  return ConfigurationType2;
})(ConfigurationType || {});

// src/enums/coupon.ts
var CouponOfferType = /* @__PURE__ */ ((CouponOfferType2) => {
  CouponOfferType2["PercentageOffUpto"] = "PERCENTAGE_OFF_UPTO";
  CouponOfferType2["BuyXGetYFree"] = "BUY_X_GET_Y_FREE";
  CouponOfferType2["FlatAmountOffOnMinOrder"] = "FLAT_AMOUNT_OFF_ON_MIN_ORDER";
  return CouponOfferType2;
})(CouponOfferType || {});

// src/enums/email.ts
var EmailType = /* @__PURE__ */ ((EmailType2) => {
  EmailType2["OTP"] = "OTP";
  EmailType2["RESET_PASSWORD"] = "RESET_PASSWORD";
  EmailType2["ORDER_CONFIRMED"] = "ORDER_CONFIRMED";
  EmailType2["ORDER_TRACKING"] = "ORDER_TRACKING";
  EmailType2["SELLER_INVOICES"] = "SELLER_INVOICES";
  return EmailType2;
})(EmailType || {});
var EmailStatus = /* @__PURE__ */ ((EmailStatus2) => {
  EmailStatus2["PENDING"] = "PENDING";
  EmailStatus2["SENT"] = "SENT";
  EmailStatus2["FAILED"] = "FAILED";
  return EmailStatus2;
})(EmailStatus || {});

// src/enums/file.ts
var FileType = /* @__PURE__ */ ((FileType2) => {
  FileType2["category"] = "category";
  FileType2["subCategory"] = "subCategory";
  FileType2["product"] = "product";
  FileType2["banner"] = "banner";
  FileType2["invoice"] = "invoice";
  return FileType2;
})(FileType || {});

// src/enums/invoice.ts
var InvoiceType = /* @__PURE__ */ ((InvoiceType2) => {
  InvoiceType2["VendorToCustomer"] = "VENDOR_TO_CUSTOMER";
  InvoiceType2["FluxartToVendor"] = "FLUXART_TO_VENDOR";
  return InvoiceType2;
})(InvoiceType || {});
var InvoiceStatus = /* @__PURE__ */ ((InvoiceStatus2) => {
  InvoiceStatus2["Pending"] = "PENDING";
  InvoiceStatus2["Generated"] = "GENERATED";
  InvoiceStatus2["Failed"] = "FAILED";
  return InvoiceStatus2;
})(InvoiceStatus || {});
var InvoiceTaxType = /* @__PURE__ */ ((InvoiceTaxType2) => {
  InvoiceTaxType2["InterState"] = "INTER";
  InvoiceTaxType2["IntraState"] = "INTRA";
  return InvoiceTaxType2;
})(InvoiceTaxType || {});

// src/enums/order.ts
var OrderStatus = /* @__PURE__ */ ((OrderStatus2) => {
  OrderStatus2["Pending"] = "Pending";
  OrderStatus2["Processing"] = "Processing";
  OrderStatus2["Dispatched"] = "Dispatched";
  OrderStatus2["Shipped"] = "Shipped";
  OrderStatus2["Delivered"] = "Delivered";
  OrderStatus2["Cancelled"] = "Cancelled";
  OrderStatus2["Returned"] = "Returned";
  OrderStatus2["Disputed"] = "Disputed";
  OrderStatus2["Refunded"] = "Refunded";
  return OrderStatus2;
})(OrderStatus || {});
var OrderDeliveryType = /* @__PURE__ */ ((OrderDeliveryType2) => {
  OrderDeliveryType2["Courier"] = "Courier";
  OrderDeliveryType2["Pickup"] = "Pickup";
  OrderDeliveryType2["Transport"] = "Transport";
  return OrderDeliveryType2;
})(OrderDeliveryType || {});

// src/enums/payment.ts
var PaymentAttemptStatus = /* @__PURE__ */ ((PaymentAttemptStatus2) => {
  PaymentAttemptStatus2["Created"] = "Created";
  PaymentAttemptStatus2["Verified"] = "Verified";
  PaymentAttemptStatus2["Failed"] = "Failed";
  PaymentAttemptStatus2["Released"] = "Released";
  return PaymentAttemptStatus2;
})(PaymentAttemptStatus || {});
var PaymentEnvironment = /* @__PURE__ */ ((PaymentEnvironment2) => {
  PaymentEnvironment2["PRODUCTION"] = "PRODUCTION";
  PaymentEnvironment2["SANDBOX"] = "SANDBOX";
  return PaymentEnvironment2;
})(PaymentEnvironment || {});

// src/enums/permission.ts
var Modules = /* @__PURE__ */ ((Modules2) => {
  Modules2["Role"] = "Role";
  Modules2["User"] = "User";
  Modules2["Attribute"] = "Attribute";
  Modules2["Category"] = "Category";
  Modules2["SubCategory"] = "SubCategory";
  Modules2["SubSubCategory"] = "SubSubCategory";
  Modules2["Seller"] = "Seller";
  Modules2["Product"] = "Product";
  Modules2["ProductReview"] = "ProductReview";
  Modules2["Banner"] = "Banner";
  Modules2["Courier"] = "Courier";
  Modules2["Coupon"] = "Coupon";
  Modules2["Configuration"] = "Configuration";
  Modules2["Support"] = "Support";
  Modules2["Order"] = "Order";
  Modules2["Collection"] = "Collection";
  Modules2["Dashboard"] = "Dashboard";
  Modules2["WithdrawalRequest"] = "WithdrawalRequest";
  Modules2["Invoice"] = "Invoice";
  Modules2["Report"] = "Report";
  return Modules2;
})(Modules || {});
var Features = /* @__PURE__ */ ((Features2) => {
  Features2["Role"] = "Role";
  Features2["Permission"] = "Permission";
  Features2["User"] = "User";
  Features2["Attribute"] = "Attribute";
  Features2["AttributeDetail"] = "AttributeDetail";
  Features2["Category"] = "Category";
  Features2["SubCategory"] = "SubCategory";
  Features2["SubSubCategory"] = "SubSubCategory";
  Features2["Seller"] = "Seller";
  Features2["Product"] = "Product";
  Features2["ProductReview"] = "ProductReview";
  Features2["Banner"] = "Banner";
  Features2["Courier"] = "Courier";
  Features2["Coupon"] = "Coupon";
  Features2["Configuration"] = "Configuration";
  Features2["Support"] = "Support";
  Features2["Order"] = "Order";
  Features2["Collection"] = "Collection";
  Features2["Dashboard"] = "Dashboard";
  Features2["WithdrawalRequest"] = "WithdrawalRequest";
  Features2["Invoice"] = "Invoice";
  Features2["Report"] = "Report";
  return Features2;
})(Features || {});
var AllowedPermission = /* @__PURE__ */ ((AllowedPermission2) => {
  AllowedPermission2["create"] = "create";
  AllowedPermission2["read"] = "read";
  AllowedPermission2["update"] = "update";
  AllowedPermission2["delete"] = "delete";
  AllowedPermission2["import"] = "import";
  AllowedPermission2["export"] = "export";
  return AllowedPermission2;
})(AllowedPermission || {});

// src/enums/report.ts
var ReportType = /* @__PURE__ */ ((ReportType2) => {
  ReportType2["Orders"] = "orders";
  ReportType2["Sales"] = "sales";
  ReportType2["Settlement"] = "settlement";
  ReportType2["Gst"] = "gst";
  ReportType2["Withdrawals"] = "withdrawals";
  ReportType2["WalletTransactions"] = "wallet-transactions";
  ReportType2["ProductPerformance"] = "product-performance";
  return ReportType2;
})(ReportType || {});

// src/enums/seller.ts
var SellerFulfillmentType = /* @__PURE__ */ ((SellerFulfillmentType2) => {
  SellerFulfillmentType2["Self"] = "Self";
  SellerFulfillmentType2["Platform"] = "Platform";
  return SellerFulfillmentType2;
})(SellerFulfillmentType || {});

// src/enums/product.ts
var ProductStatus = /* @__PURE__ */ ((ProductStatus2) => {
  ProductStatus2["UnderReview"] = "Under Review";
  ProductStatus2["Verified"] = "Verified";
  ProductStatus2["Rejected"] = "Rejected";
  return ProductStatus2;
})(ProductStatus || {});

// src/enums/otp.ts
var OtpReason = /* @__PURE__ */ ((OtpReason2) => {
  OtpReason2["EMAIL_VERIFICATION"] = "EMAIL_VERIFICATION";
  OtpReason2["MOBILE_VERIFICATION"] = "MOBILE_VERIFICATION";
  OtpReason2["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
  OtpReason2["PICKUP_ORDER"] = "PICKUP_ORDER";
  return OtpReason2;
})(OtpReason || {});

// src/enums/support.ts
var SupportStatus = /* @__PURE__ */ ((SupportStatus2) => {
  SupportStatus2["Open"] = "Open";
  SupportStatus2["InProgress"] = "In Progress";
  SupportStatus2["Resolved"] = "Resolved";
  SupportStatus2["Closed"] = "Closed";
  return SupportStatus2;
})(SupportStatus || {});

// src/enums/user.ts
var UserType = /* @__PURE__ */ ((UserType2) => {
  UserType2["Admin"] = "Admin";
  UserType2["User"] = "User";
  UserType2["Seller"] = "Seller";
  return UserType2;
})(UserType || {});

// src/enums/wallet.ts
var WalletTransactionType = /* @__PURE__ */ ((WalletTransactionType2) => {
  WalletTransactionType2["Credit"] = "Credit";
  WalletTransactionType2["Debit"] = "Debit";
  return WalletTransactionType2;
})(WalletTransactionType || {});

// src/enums/withdrawal.ts
var WithdrawalStatus = /* @__PURE__ */ ((WithdrawalStatus2) => {
  WithdrawalStatus2["Requested"] = "Requested";
  WithdrawalStatus2["Processing"] = "Processing";
  WithdrawalStatus2["Completed"] = "Completed";
  WithdrawalStatus2["Rejected"] = "Rejected";
  WithdrawalStatus2["Failed"] = "Failed";
  return WithdrawalStatus2;
})(WithdrawalStatus || {});

// src/types/report.ts
var REPORT_DEFINITIONS = [
  {
    type: "orders" /* Orders */,
    title: "Orders Report",
    description: "Download all orders with customer, seller, payment, and shipping details."
  },
  {
    type: "sales" /* Sales */,
    title: "Sales Report",
    description: "Line-item level sales report with product, SKU, quantity, and revenue."
  },
  {
    type: "settlement" /* Settlement */,
    title: "Settlement Report",
    description: "Seller settlement breakdown including platform fees, earnings, and tax deductions."
  },
  {
    type: "gst" /* Gst */,
    title: "GST / Tax Report",
    description: "Invoice-level tax report with CGST, SGST, IGST, and taxable amounts."
  },
  {
    type: "withdrawals" /* Withdrawals */,
    title: "Withdrawal Report",
    description: "Payout and withdrawal requests with status, UTR, and processing details."
  },
  {
    type: "wallet-transactions" /* WalletTransactions */,
    title: "Wallet Transactions",
    description: "Credit and debit transactions across seller and user wallets."
  },
  {
    type: "product-performance" /* ProductPerformance */,
    title: "Product Performance",
    description: "Top-selling products by units sold and revenue for the selected period."
  }
];

// src/utils/constants.ts
var endpoints = {
  auth: {
    login: "/auth/login",
    refresh: "/auth/refresh",
    logout: "/auth/logout",
    sendOtp: "/auth/send-otp",
    validateOtp: "/auth/validate-otp",
    forgotPassword: {
      sendOtp: "/auth/forgot-password/send-otp",
      verifyOtp: "/auth/forgot-password/verify-otp"
    },
    resetPassword: "/auth/reset-password",
    customer: {
      signup: "/auth/customer/signup"
    },
    seller: {
      signup: "/auth/seller/signup"
    }
  },
  dashboard: {
    metrics: "/dashboard/metrics"
  },
  users: {
    index: "/users",
    id: (id) => `/users/${id}`
  },
  user: {
    index: "/user",
    profile: "/user/profile",
    account: "/user/account",
    id: (id) => `/user/${id}`,
    paginated: "/user/paginate"
  },
  search: {
    index: "/search"
  },
  permission: {
    index: "/permission",
    id: (id) => `/permission/${id}`
  },
  courier: {
    index: "/courier",
    id: (id) => `/courier/${id}`,
    paginated: "/courier/paginate"
  },
  file: {
    index: "/file"
    // id: (id: string) => `/file/${id}`,
  },
  role: {
    index: "/role",
    id: (id) => `/role/${id}`,
    paginated: "/role/paginate"
  },
  category: {
    index: "/category",
    id: (id) => `/category/${id}`,
    paginated: "/category/paginate"
  },
  subCategory: {
    index: "/sub-category",
    id: (id) => `/sub-category/${id}`,
    paginated: "/sub-category/paginate"
  },
  subSubCategory: {
    index: "/sub-sub-category",
    id: (id) => `/sub-sub-category/${id}`,
    paginated: "/sub-sub-category/paginate"
  },
  seller: {
    index: "/seller",
    id: (id) => `/seller/${id}`,
    paginated: "/seller/paginate",
    statistics: "/seller/statistics"
  },
  attribute: {
    index: "/attribute",
    id: (id) => `/attribute/${id}`,
    paginated: "/attribute/paginate"
  },
  product: {
    index: "/product",
    id: (id) => `/product/${id}`,
    paginated: "/product/paginate"
  },
  review: {
    index: "/review"
  },
  productVariant: {
    index: "/product-variant",
    id: (id) => `/product-variant/${id}`,
    paginated: "/product-variant/paginate"
  },
  productReview: {
    index: "/product-review",
    id: (id) => `/product-review/${id}`,
    paginated: "/product-review/paginate"
  },
  cartItem: {
    index: "/cart-item",
    id: (id) => `/cart-item/${id}`
  },
  banner: {
    index: "/banner",
    id: (id) => `/banner/${id}`,
    paginated: "/banner/paginate"
  },
  coupon: {
    index: "/coupon",
    id: (id) => `/coupon/${id}`,
    paginated: "/coupon/paginate",
    apply: "/coupon/apply"
  },
  userAddress: {
    index: "/user-address",
    id: (id) => `/user-address/${id}`,
    default: "/user-address/default"
  },
  order: {
    index: "/order",
    id: (id) => `/order/${id}`,
    paginated: "/order/paginate",
    myOrders: "/order/my-orders",
    sellerOrders: "/order/seller-orders"
  },
  payment: {
    createOrder: "/payment/create-order",
    verify: "/payment/verify",
    status: "/payment/status",
    releaseReservation: "/payment/release-reservation"
  },
  wishlist: {
    index: "/wishlist",
    id: (id) => `/wishlist/${id}`,
    paginated: "/wishlist/paginated"
  },
  support: {
    index: "/support",
    id: (id) => `/support/${id}`,
    paginated: "/support/paginated",
    myRequests: "/support/my-requests"
  },
  wallet: {
    contextsMe: "/wallet/contexts/me",
    transactions: (walletId) => `/wallet/${walletId}/transactions`,
    withdraw: (walletId) => `/wallet/${walletId}/withdraw`,
    bankDetails: (walletId) => `/wallet/${walletId}/bank-details`
  },
  withdrawal: {
    index: "/withdrawal",
    id: (id) => `/withdrawal/${id}`,
    paginated: "/withdrawal/paginated",
    me: "/withdrawal/me",
    byWallet: (walletId) => `/withdrawal/wallet/${walletId}`,
    updateStatus: (id) => `/withdrawal/${id}/status`
  },
  collection: {
    index: "/collection",
    id: (id) => `/collection/${id}`,
    paginated: "/collection/paginate",
    productVariantsPaginated: (id) => `/collection/${id}/product-variants/paginate`
  },
  invoice: {
    index: "/invoice",
    id: (id) => `/invoice/${id}`,
    paginated: "/invoice/paginated",
    render: (id) => `/invoice/${id}/render`,
    sellerZip: "/invoice/seller/zip",
    uploadPending: "/invoice/upload-pending"
  },
  report: {
    catalog: "/report/catalog",
    download: (type) => `/report/${type}/download`
  },
  referral: {
    me: "/referral/me"
  }
};
var regexPatterns = {
  phoneNumber: new RegExp("^[+]?[0-9]{10,13}$"),
  itsNumber: new RegExp("^[0-9]{8}$"),
  postalCode: new RegExp("^[0-9]{6}$"),
  panNumber: new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$"),
  aadhaarNumber: new RegExp("^[2-9]{1}[0-9]{11}$"),
  gumastaLicense: new RegExp("^[A-Z]{4}[0-9]{6}[A-Z]{2}[0-9]{6}$"),
  gstNumber: new RegExp(
    "^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
  ),
  cinNumber: new RegExp(
    "^([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$"
  ),
  password: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{8,}$"),
  // At least 8 characters, one uppercase, one lowercase, and one number
  ifscCode: new RegExp("^[A-Z]{4}0[A-Z0-9]{6}$")
};
var companyName = "Fluxart Solutions Private Limited";
var companyAddress = "A78 Hasanji Nagar, Indore, Madhya Pradesh, 453331, India";
var companyState = "Madhya Pradesh";
var companyGSTIN = "23AAGCF3411M1ZT";
var companyPAN = "AAGCF3411M";
var SEARCH_DEBOUNCE_DELAY = 400;
var defaultPaginationOptions = {
  page: 1,
  limit: 20,
  sortBy: "createdAt",
  sortOrder: "DESC",
  search: ""
};
var ACCESS_TOKEN_COOKIE_NAME = "access_token";
var REFRESH_TOKEN_COOKIE_NAME = "refresh_token";
var USER_DELETION_GRACE_PERIOD_DAYS = 90;
var MAX_ORDER_REMARK_LENGTH = 500;
var DEFAULT_APP_PERCENTAGE = 10;

// src/utils/email.ts
var SYNC_EMAIL_TYPES = /* @__PURE__ */ new Set([
  "OTP" /* OTP */,
  "RESET_PASSWORD" /* RESET_PASSWORD */
]);
function toEmailJobData(email) {
  return {
    type: email.type,
    email: email.email,
    data: email.data,
    attachments: email.attachments?.map((attachment) => {
      let contentBase64;
      if (attachment.content !== void 0) {
        contentBase64 = Buffer.isBuffer(attachment.content) ? attachment.content.toString("base64") : Buffer.from(attachment.content).toString("base64");
      } else if (attachment.path) {
        throw new Error(
          `Path-based attachments cannot be queued: ${attachment.filename ?? attachment.path}`
        );
      }
      if (!contentBase64) {
        throw new Error(
          `Attachment ${attachment.filename ?? "unknown"} has no content`
        );
      }
      return {
        filename: attachment.filename ?? "attachment",
        contentBase64,
        contentType: attachment.contentType
      };
    })
  };
}
function fromEmailJobData(job) {
  return {
    type: job.type,
    email: job.email,
    data: job.data,
    attachments: job.attachments?.map((attachment) => ({
      filename: attachment.filename,
      content: Buffer.from(attachment.contentBase64, "base64"),
      contentType: attachment.contentType
    }))
  };
}

// src/utils/order.ts
function calculateWeightBasedShippingCharge(shippingChargePerKg, totalWeightInKg) {
  const safeRate = Number(shippingChargePerKg || 0);
  const safeWeight = Number(totalWeightInKg || 0);
  if (safeRate <= 0 || safeWeight <= 0) {
    return 0;
  }
  return Number((safeRate * Math.ceil(safeWeight)).toFixed(2));
}

// src/utils/cart.ts
function getApplicableBulkPrice(bulkPrices, quantity) {
  const sortedBulkPrices = [...bulkPrices || []].sort(
    (left, right) => left.quantity - right.quantity
  );
  let matchedBulkPrice = null;
  for (const bulkPrice of sortedBulkPrices) {
    if (quantity >= bulkPrice.quantity) {
      matchedBulkPrice = bulkPrice;
    }
  }
  return matchedBulkPrice;
}
function getUnitPrice(variant, quantity) {
  return getApplicableBulkPrice(variant.bulkPrices, quantity)?.price ?? Number(variant.discountedPrice || 0);
}
function calculateCartItemSubtotal(item) {
  return getUnitPrice(item.productVariant, item.quantity) * item.quantity;
}
function calculateCartSubtotal(items) {
  return items.reduce((sum, item) => sum + calculateCartItemSubtotal(item), 0);
}
function calculateCartShippingCharge(items, options) {
  const sellerShippingMap = /* @__PURE__ */ new Map();
  const sellerTransportMap = /* @__PURE__ */ new Map();
  const sellerWeightMap = /* @__PURE__ */ new Map();
  for (const item of items) {
    const sellerId = item.productVariant.sellerId;
    if (!sellerId) {
      continue;
    }
    if (!sellerShippingMap.has(sellerId)) {
      sellerShippingMap.set(
        sellerId,
        Number(item.productVariant.seller?.shippingCharge ?? 0)
      );
      sellerTransportMap.set(
        sellerId,
        Number(item.productVariant.seller?.transportCharge ?? 0)
      );
    }
    const itemWeight = Number(item.productVariant.weight || 0) * item.quantity;
    sellerWeightMap.set(
      sellerId,
      Number((sellerWeightMap.get(sellerId) ?? 0) + itemWeight)
    );
  }
  let shippingCharge = 0;
  for (const [sellerId, shippingPerKg] of sellerShippingMap.entries()) {
    const totalWeight = sellerWeightMap.get(sellerId) ?? 0;
    const transportCharge = sellerTransportMap.get(sellerId) ?? 0;
    const deliveryType = options?.sellerDeliveryTypes?.[sellerId] ?? "Courier" /* Courier */;
    shippingCharge += calculateSellerDeliveryCharge(
      deliveryType,
      shippingPerKg,
      totalWeight,
      transportCharge
    );
  }
  return Number(shippingCharge.toFixed(2));
}
function calculateSellerDeliveryCharge(deliveryType, shippingChargePerKg, totalWeight, transportCharge = 0) {
  if (deliveryType === "Pickup" /* Pickup */) {
    return 0;
  }
  if (deliveryType === "Transport" /* Transport */) {
    return Number((transportCharge || 0).toFixed(2));
  }
  return calculateWeightBasedShippingCharge(shippingChargePerKg, totalWeight);
}

// src/utils/date.ts
function formatDate(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }
  return date.toLocaleString();
}

// src/utils/number.ts
var priceFormat = (price, includeDecimals = false) => {
  return price.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: includeDecimals ? 2 : 0,
    maximumFractionDigits: includeDecimals ? 2 : 0
  });
};
var percentFormat = (value, locale = "en-US") => {
  return new Intl.NumberFormat(locale, {
    style: "percent"
    // minimumFractionDigits: 2, // Optional: forces 2 decimal places
    // maximumFractionDigits: 2, // Optional: limits to 2 decimal places
  }).format(value / 100);
};

// src/utils/product.ts
var PRODUCT_STATUS_CLASS_NAMES = {
  ["Verified" /* Verified */]: "border-green-200 bg-green-50 text-green-700",
  ["Rejected" /* Rejected */]: "border-red-200 bg-red-50 text-red-700",
  ["Under Review" /* UnderReview */]: "border-yellow-200 bg-yellow-50 text-yellow-700"
};
var getProductStatusClassName = (status) => PRODUCT_STATUS_CLASS_NAMES[status];
var isVariantInStock = (variant) => {
  if (variant.alwaysAvailable) {
    return true;
  }
  return (variant.stock ?? 0) - (variant.reservedStock ?? 0) > 0;
};
var getAvailableStock = (variant) => {
  if (variant.alwaysAvailable) {
    return Number.MAX_SAFE_INTEGER;
  }
  return Math.max(0, (variant.stock ?? 0) - (variant.reservedStock ?? 0));
};

// src/utils/query.ts
function buildQueryString(updates) {
  const params = new URLSearchParams();
  for (const key in updates) {
    if (updates[key] !== void 0 && updates[key] !== null) {
      params.append(key, String(updates[key]));
    }
  }
  const queryString = params.toString();
  return queryString ? `?${queryString}` : "";
}

// src/utils/string.ts
var trimString = ({ value }) => typeof value === "string" ? value.trim() : value;
var addUserAddressInputSchema = z.object({
  label: z.string().trim().optional(),
  fullName: z.string().trim().min(2, { message: "Full name is required." }),
  phone: z.string().trim().regex(regexPatterns.phoneNumber, {
    message: "Please enter a valid phone number."
  }),
  senderName: z.string().trim().optional(),
  senderPhone: z.string().trim().regex(regexPatterns.phoneNumber, {
    message: "Please enter a valid phone number."
  }).optional().or(z.literal("")),
  addressLine1: z.string().trim().min(2, {
    message: "Address line 1 is required."
  }),
  addressLine2: z.string().trim().optional(),
  city: z.string().trim().min(2, { message: "City is required." }),
  state: z.string().trim().min(2, { message: "State is required." }),
  pincode: z.string().trim().regex(regexPatterns.postalCode, {
    message: "Please enter a valid 6 digit pincode."
  }),
  country: z.string().trim().min(2, { message: "Country is required." }),
  preferredCourier: z.string().trim().optional(),
  preferredTransport: z.string().trim().optional(),
  isDefault: z.boolean().optional()
});
var updateUserAddressInputSchema = addUserAddressInputSchema.partial();
var addAttributeDetailInputSchema = z.object({
  id: z.string().uuid().optional(),
  value: z.string().min(1, "Detail value is required"),
  isActive: z.boolean().optional()
});
var addAttributeInputSchema = z.object({
  name: z.string().min(2, "Attribute name is required"),
  type: z.nativeEnum(AttributeType),
  isVariant: z.boolean(),
  displayOrder: z.number().int().min(0, "Display order must be 0 or more"),
  attributeDetails: z.array(addAttributeDetailInputSchema).optional()
});
var passwordSchema = z.string().min(8, {
  message: "Password must be at least 8 characters."
});
var customerSignUpInputSchema = z.object({
  fullName: z.string().min(2, { message: "Full Name is required." }),
  email: z.email({ message: "Invalid email address." }).optional().or(z.literal("")),
  phoneNumber: z.string().trim().regex(regexPatterns.phoneNumber, { message: "Invalid mobile number." }),
  its: z.string().min(1, { message: "ITS is required." }),
  referralCode: z.string().optional().or(z.literal("")),
  password: passwordSchema
});
var sellerSignUpInputSchema = z.object({
  name: z.string().min(2, { message: "Business Name is required" }),
  phoneNumber: z.string().min(10, { message: "Phone Number must be valid 10 digits" }),
  email: z.string().email({ message: "Invalid email address" }),
  password: z.string().regex(regexPatterns.password, {
    message: "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, and one number."
  }),
  addressLine1: z.string().min(2, { message: "Address Line 1 is required" }),
  addressLine2: z.string().optional(),
  city: z.string().min(2, { message: "City is required" }),
  state: z.string().min(2, { message: "State is required" }),
  country: z.string().min(2, { message: "Country is required" }),
  postalCode: z.string().min(5, { message: "Postal Code is required" }),
  shippingCharge: z.number().min(0, { message: "Shipping Charges must be positive" }),
  transportCharge: z.number().min(0, { message: "Transport Charge must be positive" }),
  panNumber: z.string().regex(regexPatterns.panNumber, {
    message: "Please enter valid PAN"
  }).or(z.literal("")).optional(),
  gstNumber: z.string().regex(regexPatterns.gstNumber, {
    message: "Please enter valid GST Number"
  }).or(z.literal("")).optional(),
  gumastaLicense: z.string().regex(regexPatterns.gumastaLicense, {
    message: "Please enter valid Gumasta License Number"
  }).or(z.literal("")).optional(),
  authorizedSignatory: z.string().min(1, { message: "Authorized Signatory is required" }),
  cinNumber: z.string().regex(regexPatterns.cinNumber, {
    message: "Please enter valid CIN Number (if applicable, else leave empty)"
  }).or(z.literal("")).optional()
});
var loginInputSchema = z.object({
  email: z.email({
    message: "Please enter a valid email id."
  }).optional().or(z.literal("")),
  mobile: z.string().trim().regex(regexPatterns.phoneNumber, {
    message: "Please enter a valid mobile number."
  }).optional().or(z.literal("")),
  password: passwordSchema
}).refine((value) => !!value.email || !!value.mobile, {
  message: "Please enter email or mobile number.",
  path: ["email"]
});
var forgotPasswordSendOtpInputSchema = z.object({
  email: z.email({
    message: "Please enter a valid email id."
  })
});
var forgotPasswordVerifyOtpInputSchema = z.object({
  email: z.email({
    message: "Please enter a valid email address."
  }),
  otp: z.string().min(6, {
    message: "Please enter a valid OTP."
  })
});
var forgotPasswordResetPasswordInputSchema = z.object({
  newPassword: passwordSchema,
  resetPasswordToken: z.string().min(1, {
    message: "Reset password token is required."
  })
});
var addBannerInputSchema = z6.object({
  name: z6.string().min(3, "Banner name is required"),
  link: z6.string().min(3, "Banner link is required"),
  displayOrder: z6.number().optional(),
  image: z6.custom((file) => file, "Image is required").optional()
});
var updateBannerInputSchema = addBannerInputSchema.partial().extend({
  isActive: z6.boolean().optional()
});
var addCollectionInputSchema = z.object({
  name: z.string().min(1, "Collection name is required"),
  subSubCategoryIds: z.array(z.uuid({ message: "Invalid sub-sub-category ID" })).min(1, "At least one sub-sub-category must be selected"),
  displayOrder: z.number().min(0, "Display order must be a non-negative number")
});
var addCouponInputSchema = z6.object({
  code: z6.string().min(2, "Coupon code is required"),
  name: z6.string().min(2, "Coupon name is required"),
  description: z6.string().optional(),
  offerType: z6.enum(CouponOfferType),
  percentageOff: z6.number().optional(),
  maxDiscountAmount: z6.number().optional(),
  buyQuantity: z6.number().int().optional(),
  freeQuantity: z6.number().int().optional(),
  flatDiscountAmount: z6.number().optional(),
  minOrderAmount: z6.number().optional(),
  startsAt: z6.string().optional(),
  endsAt: z6.string().optional(),
  usageLimit: z6.number().int().optional(),
  maxUsesPerUser: z6.number().int().optional(),
  showInCart: z6.boolean().optional(),
  isActive: z6.boolean().optional()
}).superRefine((values, context) => {
  if (values.offerType === "PERCENTAGE_OFF_UPTO" /* PercentageOffUpto */) {
    if (!values.percentageOff || values.percentageOff <= 0) {
      context.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["percentageOff"],
        message: "Percentage off is required"
      });
    }
    if (!values.maxDiscountAmount || values.maxDiscountAmount <= 0) {
      context.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["maxDiscountAmount"],
        message: "Max discount amount is required"
      });
    }
  }
  if (values.offerType === "BUY_X_GET_Y_FREE" /* BuyXGetYFree */) {
    if (!values.buyQuantity || values.buyQuantity <= 0) {
      context.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["buyQuantity"],
        message: "Buy quantity is required"
      });
    }
    if (!values.freeQuantity || values.freeQuantity <= 0) {
      context.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["freeQuantity"],
        message: "Free quantity is required"
      });
    }
  }
  if (values.offerType === "FLAT_AMOUNT_OFF_ON_MIN_ORDER" /* FlatAmountOffOnMinOrder */) {
    if (!values.flatDiscountAmount || values.flatDiscountAmount <= 0) {
      context.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["flatDiscountAmount"],
        message: "Flat discount amount is required"
      });
    }
    if (!values.minOrderAmount || values.minOrderAmount <= 0) {
      context.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["minOrderAmount"],
        message: "Minimum order amount is required"
      });
    }
  }
  if (values.startsAt && values.endsAt) {
    const startsAt = new Date(values.startsAt);
    const endsAt = new Date(values.endsAt);
    if (startsAt > endsAt) {
      context.addIssue({
        code: z6.ZodIssueCode.custom,
        path: ["endsAt"],
        message: "End date should be after start date"
      });
    }
  }
});
var updateOrderInputSchema = z.object({
  status: z.enum(OrderStatus),
  shippingName: z.string().trim().min(2, {
    message: "Customer name is required."
  }),
  shippingPhone: z.string().trim().regex(regexPatterns.phoneNumber, {
    message: "Please enter a valid phone number."
  }),
  shippingAddressLine1: z.string().trim().min(2, {
    message: "Address line 1 is required."
  }),
  shippingAddressLine2: z.string().trim().optional(),
  shippingCity: z.string().trim().min(2, {
    message: "City is required."
  }),
  shippingState: z.string().trim().min(2, {
    message: "State is required."
  }),
  shippingPincode: z.string().trim().regex(regexPatterns.postalCode, {
    message: "Please enter a valid 6 digit pincode."
  }),
  shippingCountry: z.string().trim().min(2, {
    message: "Country is required."
  })
});
var addProductReviewInputSchema = z6.object({
  productId: z6.uuid({
    message: "Product ID must be a valid UUID"
  }),
  rating: z6.number({
    message: "Rating must be a number"
  }).min(1, {
    message: "Rating must be at least 1"
  }).max(5, {
    message: "Rating cannot be more than 5"
  }),
  title: z6.string({
    message: "Title must be a string"
  }).min(1, {
    message: "Title is required"
  }).max(100, {
    message: "Title cannot exceed 100 characters"
  }),
  message: z6.string({
    message: "Message must be a string"
  }).min(1, {
    message: "Message is required"
  }).max(500, {
    message: "Message cannot exceed 500 characters"
  })
});
var fileOrStringSchema = z.custom(
  (value) => value instanceof File || typeof value === "string" && value.trim() !== "",
  {
    message: "Please upload a valid image"
  }
);
var addProductVariantAttributeSchema = z.object({
  attributeId: z.string(),
  value: z.string().min(1, { message: "Variant attribute value is required" })
});
var addProductVariantBulkPriceSchema = z.object({
  quantity: z.number().positive({
    message: "Minimum quantity must be a positive number"
  }),
  price: z.number().positive({ message: "Bulk price must be a positive number" })
});
var addProductVariantInputSchema = z.object({
  variantAttributes: z.array(addProductVariantAttributeSchema),
  bulkPrices: z.array(addProductVariantBulkPriceSchema),
  price: z.number().positive({ message: "Price must be a positive number" }),
  weight: z.number().max(50, { message: "Weight must be less than or equal to 50" }),
  discountedPrice: z.number().positive({ message: "Discounted Price must be a positive number" }),
  sku: z.string().min(1, { message: "Discounted Price is required" }),
  stock: z.number().int(),
  featuredImage: fileOrStringSchema,
  additionalImages: z.array(fileOrStringSchema).min(1, {
    message: "At least one additional image is required"
  }),
  alwaysAvailable: z.boolean().optional(),
  isActive: z.boolean().optional()
});
var addProductInputSchema = z.object({
  name: z.string().min(3, { message: "Name is required" }),
  description: z.string().min(3, { message: "Description is required" }),
  sellerId: z.string().uuidv4().min(1, { message: "Seller ID is required" }),
  categoryIds: z.array(z.string()).min(1, { message: "At least one category is required" }),
  subCategoryIds: z.array(z.string()).min(1, { message: "At least one sub category is required" }),
  subSubCategoryIds: z.array(z.string()).min(1, { message: "At least one sub sub category is required" }),
  variants: z.array(addProductVariantInputSchema),
  location: z.string().min(1, { message: "Location is required" }),
  hsn: z.string().min(1, { message: "HSN is required" }),
  gstRate: z.coerce.number().min(0, { message: "GST rate is required" }),
  ean: z.string().optional()
});
var updateProductInputSchema = addProductInputSchema.partial().extend({
  status: z.enum(ProductStatus).optional()
});
var addSellerInputSchema = z.object({
  name: z.string().min(2, { message: "Business Name is required" }),
  phoneNumber: z.string().min(10, { message: "Phone Number must be valid 10 digits" }),
  email: z.string().email({ message: "Invalid email address" }),
  password: z.string().regex(regexPatterns.password, {
    message: "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, and one number."
  }),
  addressLine1: z.string().min(2, { message: "Address Line 1 is required" }),
  addressLine2: z.string().optional(),
  city: z.string().min(2, { message: "City is required" }),
  state: z.string().min(2, { message: "State is required" }),
  country: z.string().min(2, { message: "Country is required" }),
  postalCode: z.string().min(5, { message: "Postal Code is required" }),
  shippingCharge: z.number().min(0, { message: "Shipping Charges must be positive" }),
  transportCharge: z.number().min(0, { message: "Transport Charge must be positive" }),
  fulfillmentType: z.enum(SellerFulfillmentType).optional(),
  appPercentage: z.number().min(0, { message: "App percentage must be between 0 and 100" }).max(100, { message: "App percentage must be between 0 and 100" }),
  panNumber: z.string().regex(regexPatterns.panNumber, {
    message: "Please enter valid PAN"
  }).or(z.literal("")).optional(),
  gstNumber: z.string().regex(regexPatterns.gstNumber, {
    message: "Please enter valid GST Number"
  }).or(z.literal("")).optional(),
  gumastaLicense: z.string().regex(regexPatterns.gumastaLicense, {
    message: "Please enter valid Gumasta License Number"
  }).or(z.literal("")).optional(),
  authorizedSignatory: z.string().min(1, { message: "Authorized Signatory is required" }),
  cinNumber: z.string().regex(regexPatterns.cinNumber, {
    message: "Please enter valid CIN Number (if applicable, else leave empty)"
  }).or(z.literal("")).optional()
});
var addSellerByAdminInputSchema = addSellerInputSchema.extend({
  ownerPhoneNumber: z.string().trim().regex(regexPatterns.phoneNumber, {
    message: "Please enter a valid phone number."
  }).optional().or(z.literal(""))
});
var updateSellerInputSchema = addSellerInputSchema.partial().extend({
  password: z.string().regex(regexPatterns.password, {
    message: "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, and one number."
  }).or(z.literal("")).optional(),
  isActive: z.boolean().optional(),
  isVerified: z.boolean().optional()
});
var addCategoryAttributeInputSchema = z6.object({
  attributeId: z6.string().uuid({ message: "Attribute ID must be a valid UUID" }),
  isRequired: z6.boolean(),
  isVariant: z6.boolean()
});
var addSubSubCategoryInputSchema = z6.object({
  name: z6.string().min(3, "Sub Sub Category name is required"),
  displayOrder: z6.number().min(0, "Display order must be a non-negative number"),
  homeScreenDisplayOrder: z6.number().min(0, "Display order must be a non-negative number"),
  categoryId: z6.string().uuid({ message: "Category ID must be a valid UUID" }),
  subCategoryId: z6.string().uuid({ message: "Sub Category ID must be a valid UUID" }),
  categoryAttributes: z6.array(addCategoryAttributeInputSchema),
  image: z6.custom((file) => file, "Image is required").optional(),
  showOnHomeScreen: z6.boolean().optional()
});
var updateSubSubCategoryInputSchema = addSubSubCategoryInputSchema.partial().extend({
  isActive: z6.boolean().optional()
});
var addSupportRequestInputSchema = z.object({
  name: z.string().trim().min(2, {
    message: "Name must be at least 2 characters."
  }),
  email: z.email({
    message: "Please enter a valid email address."
  }),
  message: z.string().trim().min(10, {
    message: "Message must be at least 10 characters."
  })
});
var addUserInputSchema = z.object({
  fullName: z.string().min(2, { message: "Full Name is required." }),
  phoneNumber: z.string().regex(regexPatterns.phoneNumber, { message: "Invalid phone number." }),
  its: z.string().regex(regexPatterns.itsNumber, { message: "Invalid ITS number." }),
  email: z.email({ message: "Invalid email address." }).optional().or(z.literal("")),
  referralCode: z.string().optional().or(z.literal("")),
  password: z.string().min(8, { message: "Password must be at least 8 characters long." }),
  roleId: z.string().optional(),
  type: z.enum(UserType),
  isActive: z.boolean().optional()
});
var updateUserInputSchema = addUserInputSchema.partial();
var updateProfileSchema = z.object({
  fullName: z.string().min(2, { message: "Full name is required." }),
  phoneNumber: z.string().regex(regexPatterns.phoneNumber, { message: "Invalid phone number." }),
  its: z.string().regex(regexPatterns.itsNumber, {
    message: "ITS number must be exactly 8 digits."
  }),
  isActive: z.boolean().optional()
});
var deleteUserInputSchema = z.object({
  password: z.string().min(1, { message: "Password is required." })
});
var createWalletTransactionInputSchema = z.object({
  type: z.enum(WalletTransactionType),
  amount: z.number({ message: "Amount is required." }).min(0.01, { message: "Amount must be greater than 0." }),
  description: z.string().trim().min(1, { message: "Description cannot be empty." }).optional(),
  referenceType: z.string().trim().min(1, { message: "Reference type cannot be empty." }).optional(),
  referenceId: z.string().trim().min(1, { message: "Reference id cannot be empty." }).optional(),
  metadata: z.record(z.string(), z.unknown()).optional()
});
var withdrawWalletAmountInputSchema = z.object({
  amount: z.number({ message: "Amount is required." }).min(0.01, { message: "Amount must be greater than 0." }),
  description: z.string().trim().optional(),
  referenceId: z.string().trim().optional(),
  metadata: z.record(z.string(), z.unknown()).optional()
});
var addBankDetailInputSchema = z.object({
  accountHolderName: z.string().trim().min(1, "Account holder name is required"),
  accountNumber: z.string().trim().min(1, "Account number is required"),
  ifsc: z.string().trim().min(1, "IFSC code is required").regex(regexPatterns.ifscCode, "Invalid IFSC code format")
});
var createWithdrawalRequestInputSchema = z.object({
  amount: z.number({ message: "Amount is required." }).min(0.01, { message: "Amount must be greater than 0." }),
  description: z.string().trim().optional(),
  referenceId: z.string().trim().optional(),
  metadata: z.record(z.string(), z.unknown()).optional()
});
var updateWithdrawalStatusInputSchema = z.object({
  status: z.enum(WithdrawalStatus, {
    message: `Status must be one of ${Object.values(WithdrawalStatus).join(", ")}`
  }),
  processingReference: z.string().trim().optional(),
  processingRemarks: z.string().trim().optional()
});

export { ACCESS_TOKEN_COOKIE_NAME, AllowedPermission, AttributeType, ConfigurationKey, ConfigurationType, CouponOfferType, DEFAULT_APP_PERCENTAGE, EmailStatus, EmailType, Features, FileType, InvoiceStatus, InvoiceTaxType, InvoiceType, MAX_ORDER_REMARK_LENGTH, Modules, OrderDeliveryType, OrderStatus, OtpReason, PRODUCT_STATUS_CLASS_NAMES, PaymentAttemptStatus, PaymentEnvironment, ProductStatus, REFRESH_TOKEN_COOKIE_NAME, REPORT_DEFINITIONS, ReportType, SEARCH_DEBOUNCE_DELAY, SYNC_EMAIL_TYPES, SellerFulfillmentType, SupportStatus, USER_DELETION_GRACE_PERIOD_DAYS, UserType, WalletTransactionType, WithdrawalStatus, addAttributeInputSchema, addBankDetailInputSchema, addBannerInputSchema, addCategoryAttributeInputSchema, addCollectionInputSchema, addCouponInputSchema, addProductInputSchema, addProductReviewInputSchema, addSellerByAdminInputSchema, addSellerInputSchema, addSubSubCategoryInputSchema, addSupportRequestInputSchema, addUserAddressInputSchema, addUserInputSchema, buildQueryString, calculateCartItemSubtotal, calculateCartShippingCharge, calculateCartSubtotal, calculateSellerDeliveryCharge, calculateWeightBasedShippingCharge, companyAddress, companyGSTIN, companyName, companyPAN, companyState, createWalletTransactionInputSchema, createWithdrawalRequestInputSchema, customerSignUpInputSchema, defaultPaginationOptions, deleteUserInputSchema, endpoints, forgotPasswordResetPasswordInputSchema, forgotPasswordSendOtpInputSchema, forgotPasswordVerifyOtpInputSchema, formatDate, fromEmailJobData, getApplicableBulkPrice, getAvailableStock, getProductStatusClassName, getUnitPrice, isVariantInStock, loginInputSchema, percentFormat, priceFormat, regexPatterns, sellerSignUpInputSchema, toEmailJobData, trimString, updateBannerInputSchema, updateOrderInputSchema, updateProductInputSchema, updateProfileSchema, updateSellerInputSchema, updateSubSubCategoryInputSchema, updateUserAddressInputSchema, updateUserInputSchema, updateWithdrawalStatusInputSchema, withdrawWalletAmountInputSchema };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map